let fallback = {};

export const setItem = function(key, val) {
  try {
    return sessionStorage.setItem(key, val);
  }
  catch (error) {
    fallback[key] = val;
    return void 0;
  }
};

export const getItem = function(key) {
  try {
    return sessionStorage.getItem(key);
  }
  catch (error) {
    return fallback[key] || null;
  }
};

export const removeItem = function(key) {
  try {
    return sessionStorage.removeItem(key);
  }
  catch (error) {
    delete fallback[key];
    return void 0;
  }
};

export const clear = function() {
  try {
    return sessionStorage.clear();
  }
  catch (error) {
    fallback = {};
    return void 0;
  }
};



// WEBPACK FOOTER //
// ./src/lib/session-storage.js